import React from 'react';

export function Step(props) {
    return <div>{props.children}</div>;
}
